import React from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	return createPortal(
		<div className="nav-container">
			<nav className="navbar">
				<div className="nav-background">
					<ul className="nav-list">
						<li
							className={
								active === "home"
									? "nav-item active"
									: "nav-item"
							}
						>
							<Link to="/">Home</Link>
						</li>
						<li
							className={
								active === "experience"
									? "nav-item active"
									: "nav-item"
							}
						>
							<Link to="/experience">Experience</Link>
						</li>
						<li
							className={
								active === "projects"
									? "nav-item active"
									: "nav-item"
							}
						>
							<Link to="/projects">Projects</Link>
						</li>
						{/* <li
								className={
									active === "hobbies"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/hobbies">Off the Clock</Link>
							</li> */}
						<li
							className={
								active === "resume"
									? "nav-item active"
									: "nav-item"
							}
						>
							<a href="/resume.html" target="_blank">
								Resume
							</a>
						</li>
						{/* <li
								className={
									active === "contact"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/contact">Contact</Link>
							</li> */}
					</ul>
				</div>
			</nav>
		</div>,
		document.body,
	);
};

export default NavBar;
